import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <button
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className="relative flex h-9 w-9 items-center justify-center rounded-full border border-border/60 bg-background/90 text-foreground/80 transition-colors hover:border-primary/40 hover:text-primary hover:bg-background/100 dark:border-white/15 dark:bg-white/10 dark:text-white/80 dark:hover:border-primary/50 dark:hover:bg-white/20 shadow-sm backdrop-blur-md"
      aria-label="Toggle theme"
    >
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </button>
  );
}
